import { render, staticRenderFns } from "./ExpenseTemplatesPage.vue?vue&type=template&id=c8b55b52"
import script from "./ExpenseTemplatesPage.vue?vue&type=script&lang=js"
export * from "./ExpenseTemplatesPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports